import CircularProgress from "@mui/material/CircularProgress";

const Loader = () => {
	return <CircularProgress data-testid="loader" size={20} className={"d-flex align-self-center"} />;
};

export default Loader;
